"use strict";
// Updated from commit 94428f89bf25e3df92827c5bc677da8452aa7d12 - vscode/src/vs/base/common/charCode.ts
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
